export default __webpack_public_path__ + "static/media/image_logo.be6241be.svg";